export default {"src":"/_next/static/media/walking.colour.9e3cacf2.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};